import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, getFormValues } from 'redux-form';
import AsyncSelect from 'react-select/lib/Async';

class ReferralForm extends React.Component {
  constructor() {
    super();
    this.state = {
      typeID: 0
    };
  }

  componentDidMount() {
    const {
      initialValues: { type },
    } = this.props;

    if (type !== null) {
    this.setState({ typeID: type.id });
    }
  }

  componentWillMount() {
    const {
      initialValues: { type },
    } = this.props;

    if (type !== null) {
      this.setState({ typeID: type.id });
    }
  }

  renderField = ({
    input,
    label,
    type,
    disabled,
    readOnly,
    meta: { touched, error, warning },
  }) => (
      <div className={`form-group ${error ? 'has-error' : ''}`}>
        <label className="col-md-2 control-label">{label}</label>
        <div className="col-md-10">
          <input
            {...input}
            className="form-control"
            placeholder={label}
            type={type}
            disabled={disabled}
            readOnly={readOnly}
          />
          {touched &&
            ((error && <small className="help-block">{error}</small>) ||
              (warning && <small className="help-block">{warning}</small>))}
        </div>
      </div>
  );

  renderTextArea = ({ input, label, readOnly, meta: { touched, error, warning } }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <textarea
          {...input}
          className="form-control"
          placeholder={label}
          readOnly={readOnly}
          rows="5"
          cols="30"
        />
        {touched &&
          ((error && <span>{error}</span>) ||
            (warning && <span>{warning}</span>))}
      </div>
    </div>
  );

  renderSelect = ({
    input,
    readOnly,
    meta: { touched, error, warning },
    label,
    children,
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <select {...input} className="form-control" disabled={readOnly}>
          {children}
        </select>
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  renderLocationsSelect = ({
    meta: { touched, error, warning },
    label,
    input,
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <AsyncSelect
          value={input.value}
          cacheOptions
          defaultOptions
          isMulti
          loadOptions={this.searchLocations}
          getOptionValue={(option) => option.clinicLocationID}
          getOptionLabel={(option) => (option.clinicLocation === undefined) ? option.siteName : option.clinicLocation.siteName}
          placeholder="Type Location Name..."
          styles={{
            control: styles => ({
              ...styles,
              borderColor: touched && error ? 'red' : '#cccccc',
            }),
            menu: styles => ({
              ...styles,
              zIndex: 99999,
              color: '#108ee9',
            }),
          }}
          onChange={this.onLocationChange}
        />
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  onLocationChange = (val) => {
    this.props.change('location', val);
  }

  searchLocations = (search) => {
    return this.props.searchLocations(search, 'isActive');
  }

  renderUsersSelect = ({
    meta: { touched, error, warning },
    label,
    input,
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <AsyncSelect
          value={input.value}
          cacheOptions
          defaultOptions
          //isMulti
          loadOptions={this.searchUsers}
          getOptionValue={(option) => option.id}
          getOptionLabel={(option) => option.name}
          placeholder="Type User Name..."
          styles={{
            control: styles => ({
              ...styles,
              borderColor: touched && error ? 'red' : '#cccccc',
            }),
            menu: styles => ({
              ...styles,
              zIndex: 99999,
              color: '#108ee9',
            }),
          }}
          onChange={this.onUserChange}
        />
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  searchUsers = (search) => {
    return this.props.searchUsers(search, 'isActive');
  }

  onUserChange = (val) => {
    this.props.change('owner', val);
  }

  renderTypesSelect = ({
    meta: { touched, error, warning },
    label,
    readOnly,
    input
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <AsyncSelect
          value={input.value}
          cacheOptions
          defaultOptions
          isDisabled={readOnly}
          //isMulti
          loadOptions={this.props.searchReferralTypes}
          getOptionValue={(option) => option.id}
          getOptionLabel={(option) => option.name}
          placeholder="Type..."
          styles={{
            control: styles => ({
              ...styles,
              borderColor: touched && error ? 'red' : '#cccccc',
            }),
            menu: styles => ({
              ...styles,
              zIndex: 99999,
              color: '#108ee9',
            }),
          }}
          onChange={this.onTypeChange}
        />
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  searchReferralTypes = () => {
    return this.props.searchReferralTypes();
  }

  onTypeChange = (val) => {
    this.props.change('type', val);
    this.setState({ typeID: val.id });
    this.props.change('category', null);
    this.props.searchCategoriesByType(val.id);
  }

  renderCategorySelect = ({
    meta: { touched, error, warning },
    label,
    readOnly,
    input
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <AsyncSelect
          key={this.state.typeID}
          value={input.value}
          cacheOptions
          defaultOptions
          isDisabled={readOnly}
          isMulti={this.state.typeID === 1 ? true : false}
          loadOptions={this.searchCategoriesByType}
          getOptionValue={(option) => option.id}
          getOptionLabel={(option) => option.name}
          placeholder={label}
          styles={{
            control: styles => ({
              ...styles,
              borderColor: touched && error ? 'red' : '#cccccc',
            }),
            menu: styles => ({
              ...styles,
              zIndex: 99999,
              color: '#108ee9',
            }),
          }}
          onChange={this.onCategoryChange}
        />
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  searchCategoriesByType = () => {
    return this.props.searchCategoriesByType(this.state.typeID);
  }

  onCategoryChange = (val) => {
    this.props.change('categories', val);
  }

  renderSpecialtySelect = ({
    meta: { touched, error, warning },
    label,
    readOnly,
    input
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <AsyncSelect
          key={this.state.typeID}
          value={input.value}
          cacheOptions
          defaultOptions
          isDisabled={readOnly}
          //isMulti={this.state.typeID === 1 ? true : false}
          isMulti={false}
          loadOptions={this.searchSpecialtyByType}
          getOptionValue={(option) => option.id}
          getOptionLabel={(option) => option.name}
          placeholder={label}
          styles={{
            control: styles => ({
              ...styles,
              borderColor: touched && error ? 'red' : '#cccccc',
            }),
            menu: styles => ({
              ...styles,
              zIndex: 99999,
              color: '#108ee9',
            }),
          }}
          onChange={this.onSpecialtyChange}
        />
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  searchSpecialtyByType = () => {
    return this.props.searchCategoriesByType(this.state.typeID);
  }

  onSpecialtyChange = (val) => {
    this.props.change('specialty', val);
  }

  render() {
    const {
      handleSubmit,
      pristine,
      submitting,
      mode,
      states,
    } = this.props;

    return (
      <form className="form-horizontal" onSubmit={handleSubmit}>
        <fieldset>
          <legend>Resource Referral</legend>
          {/*<Field*/}
          {/*  className="form-control"*/}
          {/*  name="resource"*/}
          {/*  component={this.renderField}*/}
          {/*  type="text"*/}
          {/*  placeholder="Resource"*/}
          {/*  label="Resource"*/}
          {/*  readOnly={mode === 'ReadOnly' ? true : false}*/}
          {/*/>*/}
          <Field
            className="form-control"
            name="organization"
            component={this.renderField}
            type="text"
            placeholder="Provider/Organization"
            label="Provider/Organization"
            readOnly={mode === 'ReadOnly' ? true : false}
          />
          <Field
            className="form-control"
            name="npiNumber"
            component={this.renderField}
            type="text"
            placeholder="NPI Number"
            label="NPI Number"
            readOnly={mode === 'ReadOnly' ? true : false}
          />
          <Field
            name="type"
            component={this.renderTypesSelect}
            label="Type"
            readOnly={mode === 'ReadOnly' ? true : false}
          />
          {(this.state.typeID === 1) && (
            <Field
              key={this.state.typeID}
              name="categories"
              component={this.renderCategorySelect}
              readOnly={mode === 'ReadOnly' ? true : false}
              label="Community Resource"
            />
            )}
          {(this.state.typeID === 2) && (
            <Field
              key={this.state.typeID}
              name="specialty"
              component={this.renderSpecialtySelect}
              readOnly={mode === 'ReadOnly' ? true : false}
              label="Specialty"
            />
          )}

          <Field
            className="form-control"
            name="insuranceProvider"
            component={this.renderField}
            type="text"
            placeholder="Insurance Provider"
            label="Insurance Provider"
            readOnly={mode === 'ReadOnly' ? true : false}
          />
          <Field
            name="location"
            component={this.renderLocationsSelect}
            label="Location"
          />
          <Field
            className="form-control"
            name="website"
            component={this.renderField}
            type="text"
            placeholder="Website"
            label="Website"
            readOnly={mode === 'ReadOnly' ? true : false}
          />
          <Field
            className="form-control"
            name="description"
            component={this.renderTextArea}
            type="text"
            placeholder="Description"
            label="Description"
            readOnly={mode === 'ReadOnly' ? true : false}
          />
          <Field
            className="form-control"
            name="hours"
            component={this.renderField}
            type="text"
            placeholder="Hours"
            label="Hours"
            readOnly={mode === 'ReadOnly' ? true : false}
          />
          <Field
            className="form-control"
            name="streetAddress"
            component={this.renderField}
            type="text"
            placeholder="StreetAddress"
            label="StreetAddress"
            readOnly={mode === 'ReadOnly' ? true : false}
          />
          <Field
            className="form-control"
            name="city"
            component={this.renderField}
            type="text"
            placeholder="City"
            label="City"
            readOnly={mode === 'ReadOnly' ? true : false}
          />
          <Field
            className="form-control"
            name="state.id"
            component={this.renderSelect}
            type="text"
            label="State"
            readOnly={mode === 'ReadOnly' ? true : false}
          >
            {states &&
              states.map(el => (
                <option key={el.id} value={el.id}>
                  {el.name}
                </option>
              ))}
          </Field>
          <Field
            className="form-control"
            name="zipCode"
            component={this.renderField}
            type="text"
            label="Zip"
            maxLength={5}
            readOnly={mode === 'ReadOnly' ? true : false}
          />
          <Field
            className="form-control"
            name="phone"
            component={this.renderField}
            type="text"
            placeholder="(XXX) XXX-XXXX"
            label="Phone Number"
            readOnly={mode === 'ReadOnly' ? true : false}
          />
          <Field
            className="form-control"
            name="fax"
            component={this.renderField}
            type="text"
            placeholder="(XXX) XXX-XXXX"
            label="Fax"
            readOnly={mode === 'ReadOnly' ? true : false}
          />
          <Field
            className="form-control"
            name="eligibilty"
            component={this.renderTextArea}
            type="text"
            placeholder="Eligibilty"
            label="Eligibilty"
            readOnly={mode === 'ReadOnly' ? true : false}
          />
          <Field
            className="form-control"
            name="referralNeeded"
            component={this.renderSelect}
            type="text"
            label="ReferralNeeded"
            readOnly={mode === 'ReadOnly' ? true : false}
          >
            <option value="true">Yes</option>
            <option value="false">No</option>
          </Field>
          <Field
            className="form-control"
            name="referralNeededDescription"
            component={this.renderTextArea}
            type="text"
            placeholder="ReferralNeededDescription"
            label="ReferralNeededDescription"
            readOnly={mode === 'ReadOnly' ? true : false}
          />
          <Field
            className="form-control"
            name="howToAccessService"
            component={this.renderTextArea}
            type="text"
            placeholder="HowToAccessService"
            label="HowToAccessService"
            readOnly={mode === 'ReadOnly' ? true : false}
          />
          <Field
            className="form-control"
            name="notesForPatient"
            component={this.renderTextArea}
            type="text"
            placeholder="NotesForPatient"
            label="NotesForPatient"
            readOnly={mode === 'ReadOnly' ? true : false}
          />
          <Field
            className="form-control"
            name="internalNotes"
            component={this.renderTextArea}
            type="text"
            placeholder="InternalNotes"
            label="InternalNotes"
            readOnly={mode === 'ReadOnly' ? true : false}
          />
          <Field
            className="form-control"
            name="qualityCheck"
            component={this.renderField}
            type="text"
            placeholder="QualityCheck"
            label="QualityCheck"
            readOnly={mode === 'ReadOnly' ? true : false}
          />
          <Field
            className="form-control"
            name="costEffectiveCheck"
            component={this.renderField}
            type="text"
            placeholder="CostEffectiveCheck"
            label="CostEffectiveCheck"
            readOnly={mode === 'ReadOnly' ? true : false}
          />
          <Field
            className="form-control"
            name="patientFeedback"
            component={this.renderTextArea}
            type="text"
            placeholder="PatientFeedback"
            label="PatientFeedback"
            readOnly={mode === 'ReadOnly' ? true : false}
          />
          <Field
            className="form-control"
            name="owner"
            component={this.renderUsersSelect}
            type="text"
            label="Record Owner"
            readOnly={mode === 'ReadOnly' ? true : false}
          />
          <Field
            className="form-control"
            name="createdByName"
            component={this.renderField}
            type="text"
            placeholder="CreatedByName"
            label="CreatedByName"
            disabled={true}
          />
          <Field
            className="form-control"
            name="createdAt"
            component={this.renderField}
            placeholder="CreatedAt"
            label="CreatedAt"
            disabled={true}
          />
          <Field
            className="form-control"
            name="updatedByName"
            component={this.renderField}
            type="text"
            placeholder="UpdatedByName"
            label="UpdatedByName"
            disabled={true}
          />
          <Field
            className="form-control"
            name="updatedAt"
            component={this.renderField}
            placeholder="UpdatedAt"
            label="UpdatedAt"
            disabled={true}
          />
        </fieldset>

        <div className="form-actions">
          <div className="row">
            <div className="col-md-12">
              <button
                onClick={this.props.onCancel}
                className="btn btn-default"
                type="button"
              >
                Cancel
              </button>{' '}
              {/* <button className="btn btn-default" type="button" disabled={pristine || submitting} onClick={reset}>
                Reset</button>{" "} */}
              <button
                className="btn btn-primary"
                type="submit"
                disabled={pristine || submitting}
              >
                <i className="fa fa-save" /> Save
              </button>
            </div>
          </div>
        </div>
      </form>
    );
  }
}
const validate = values => {
  const errors = {};
  if (!values.resource) {
    errors.resource = 'Required';
  }
  if (!values.organization) {
    errors.organization = 'Required';
  }
  if (!values.website) {
    errors.website = 'Required';
  }
  if (!values.description) {
    errors.description = 'Required';
  }
  if (!values.type) {
    errors.type = 'Required';
  }
  if (!values.hours) {
    errors.hours = 'Required';
  }
  
  return errors;
};

ReferralForm = connect(state => ({
  formValues: getFormValues('referral')(state),
  initialValues: state.referraldirectory.referral,
  enableReinitialize: true,
  validate: validate,
}))(reduxForm({ form: 'referral' })(ReferralForm));
export default ReferralForm;



// WEBPACK FOOTER //
// ./src/routes/resource-library/components/ReferralForm.js